// extracted by mini-css-extract-plugin
module.exports = {"p1i23nbj":"p1i23nbj"};